var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web_map"},[_c('el-button',{staticClass:"el-icon-download download",attrs:{"type":"primary","size":"small"},on:{"click":_vm.download}},[_vm._v("下载")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }